import { render, staticRenderFns } from "./Areas.vue?vue&type=template&id=01a84808&"
import script from "./Areas.vue?vue&type=script&lang=js&"
export * from "./Areas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports